import type { IPhoneNumber } from "@/components/formControls";
import type { ID } from "@/constants";
import type { IFileObject, IOption } from "@/interfaces";
import { EmptyOption } from "@/interfaces";

/**
 * get the file size in bytes in convert to KB, MB, GB
 * @param size file size
 */
export function humanizedFileSize(size: number) {
  if (size === 0) {
    return "0 Bytes";
  }
  const kilo = 1000;
  const dm = 2;
  const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
  const i = Math.floor(Math.log(size) / Math.log(kilo));

  return `${Number.parseFloat((size / kilo ** i).toFixed(dm))} ${sizes[i]}`;
}

/**
 * convert null or undefined to empty string ('')
 * @param value value
 */
export function nullToString(value: null | string | undefined) {
  if (value === null || value === undefined) {
    return "";
  }
  return value;
}

// function hasKey<T extends object, TK extends keyof T>(
//   value: T,
//   keys: TK,
// ): value is T & Record<TK, unknown> {
//   if (typeof value !== "object" || value === null) return false;
//   if (!Object.prototype.hasOwnProperty.call(value, keys))return false
//   // for (const key of keys) {
//   // }
//   return true
// }

/**
 * convert the empty phone number to null
 * @param value phone number
 * @returns
 */
function phoneToNull(
  value: IPhoneNumber | null | undefined,
): IPhoneNumber | null {
  if (value === undefined || value === null) return null;

  if (value.number.trim() === "") return null;

  return value;
}
/**
 * convert the empty option to null
 * @param value option value
 * @returns
 */
function optionToNull(value: IOption | null | undefined): IOption | null {
  if (value === undefined || value === null) return null;

  if (value.key.toString().trim() === "") return null;

  return value;
}
/**
 * convert the empty string to null
 * @param value string
 * @returns
 */
function stringToNull(value: string | null | undefined): string | null {
  if (value === undefined || value === null) return null;

  if (value.trim() === "") return null;

  return value;
}

export const toNull = {
  string: stringToNull,
  phone: phoneToNull,
  option: optionToNull,
};

/**
 * convert null to empty dropdown
 * @param value value
 */
export function nullToOption(value: null | IOption<ID>) {
  if (value === null) {
    return EmptyOption;
  }
  return value;
}

export function excludeNull<T>(value: null | undefined | T): T | undefined {
  if (value === null) {
    return undefined;
  }
  return value;
}

const englishChars = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "."];

export function p2e(text: string) {
  return text.replaceAll(/[٫۰-۹]/g, (char) => {
    return englishChars?.["۰۱۲۳۴۵۶۷۸۹٫"?.indexOf(char)] || char;
  });
}

export function convertImageUrlToFileObject(
  url: string | undefined | null,
): IFileObject {
  if (url === undefined || url === null) {
    return undefined;
  }
  const fileExtension = url.split(".").at(-1);

  return {
    id: "",
    name: "",
    size: 0,
    type: `image/${fileExtension}`,
    url,
  };
}
